import { useTheme } from 'styled-components';
import { LXSmallIcon } from '../../core/components/buttons/lxIcon';
import { ReactComponent as WhiteBell } from '../../../assets/icons/notificationWhite.svg';
import { IconKind } from '../../../2_domain/notification/notification';

interface NotiIconProps {
  type: IconKind;
  isNew: boolean;
}
const NotiIcon = (props: NotiIconProps) => {
  const theme = useTheme();

  const Background = {
    ICON_BELL: theme.colors.blueBg,
    ICON_WALLET: theme.colors.pinkBg,
  };

  return (
    <LXSmallIcon
      icon={WhiteBell}
      width={'40px'}
      newAlarm={props.isNew}
      backgroundColor={Background[props.type]}
    ></LXSmallIcon>
  );
};

export default NotiIcon;
